import { render, staticRenderFns } from "./AppointModal.vue?vue&type=template&id=f3578d9a&scoped=true&"
import script from "./AppointModal.vue?vue&type=script&lang=js&"
export * from "./AppointModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3578d9a",
  null
  
)

export default component.exports